<template>
  <div class="company_mobile">
    <p class="company_common_title">
      <span>{{companyName}}</span>
    </p>

    <!-- Key information -->
    <div class="key_information">
      <title-temp title="Key information"></title-temp>
      <!-- <table-form :columnData="keyColumnData" :tableData="keyTableData"></table-form> -->
      <single-column :columnData="keyColumnData" :data="keyTableData"></single-column>
    </div>

    <!-- Company overview -->
    <div class="company_overview">
      <title-temp title="Company overview"></title-temp>
      <p class="overview">{{overview}}</p>
    </div>

    <!-- Industry & activities -->
    <div class="industry_activities">
      <title-temp title="Industry & activities"></title-temp>
      <!-- <table-form :columnData="industryColumnData" :tableData="industryTableData"></table-form> -->
      <single-column :columnData="industryColumnData" :data="industryTableData"></single-column>
    </div>

    <!-- directors & managers -->
    <div class="idirectors_managers">
      <title-temp title="Directors & managers"></title-temp>
      <!-- <table-form :columnData="idirectorsColumnData" :tableData="idirectorsTableData"></table-form> -->
      <single-column :columnData="idirectorsColumnData" :data="idirectorsTableData"></single-column>
    </div>

    <div>
      <title-temp title="Key financials"></title-temp>
      <line-chart :xData="xData" :serData="serData"></line-chart>
    </div>

    <!-- Daily Quotation -->
    <div class="daily_quotation" v-if="currentDataSource !=='bvd'">
      <title-temp title="Daily Quotation"></title-temp>

      <el-date-picker
        v-model="KDatePicker"
        type="daterange"
        :picker-options="pickerOptions"
        start-placeholder="Start Date"
        end-placeholder="End Date"
        align="right"
        value-format="yyyy-MM-dd"
        @change="getQuotationData"
      ></el-date-picker>
      <k-charts :dailyKData="dailyKData"></k-charts>
    </div>

    <!-- CA Summary -->
    <!-- 06-15 增加手机端财务,ca 模块显示问题 先隐藏 -->
    <!-- <div class="ca_ummary" v-if="currentDataSource !=='bvd'">
      <title-temp title="Company announcement summary"></title-temp>
      <table-list :column="Config.caSummary" :tableData="caSummaryData" :showNumber="false">
        <template slot="other">
          <el-table-column label="Summary">
            <template slot-scope="scope">
              <span>{{getFirstSentence(scope.row.summary)}}</span>
            </template>
          </el-table-column>
        </template>
      </table-list>
    </div>-->

    <!-- add financials -->
    <Financials :conditions="conditions"></Financials>
    <!-- <FinancialsCopy :conditions="conditions"></FinancialsCopy> -->

  </div>
</template>

<script>
import TitleTemp from "common/components/Title";
import TableForm from "common/components/tableForm";
import TableList from "common/components/table";
import Financials from "./Financials";
import FinancialsCopy from "./Financials copy";


import {
  getBasic,
  getCompanyFinancial,
  getKQuotation,
  getSummary
} from "common/js/http/v2Api";
import SingleColumn from "./SingleColumn";
import LineChart from "../../BarLine";
import KCharts from "../../KCharts";
import Config from "conf/Operation";

import {
  keyColumnData,
  industryColumnData,
  idirectorsColumnData
} from "conf/Basic";

const color = [
  "#836FFF",
  "#71C671",
  "#BCD2EE",
  "#FFC962",
  "#BCD2EE",
  "#A2B5CD",
  "#A2B5CD",
  "#FFC125",
  "#757575",
  "#5E71FF",
  "#86C1FF",
  "#7583EA",
  "#FFC125",
  "#757575"
];

export default {
  props: ["conditions"],

  components: {
    TitleTemp,
    TableForm,
    SingleColumn,
    LineChart,
    KCharts,
    TableList,
    Financials,
    FinancialsCopy
  },

  data() {
    return {
      Config,
      companyName: this.conditions.companyName,
      id: this.conditions.id,
      code: this.conditions.code,
      keyColumnData,
      keyTableData: {},

      overview: "",

      industryColumnData,
      industryTableData: {},

      idirectorsColumnData,
      idirectorsTableData: {},

      xData: [],
      serData: [],
      currentDataSource: "bvd",

      // k线图 配置
      f10Id: "",
      dailyKData: [],
      KDatePicker: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "last 30 days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "last 90 days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "last 180 days",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "last year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      // caSummaryData
      caSummaryData: []
    };
  },

  created() {
    this.getCurrentDate();
    this.getBasicData();
  },

  methods: {
    getCurrentDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      this.KDatePicker = [start, end];
    },

    async getBasicData() {
      const { result } = await getBasic(this.id, this.code);
      this.keyTableData = result["Key information"];
      this.overview = result["Company Overview"].company_overview;
      this.industryTableData = result["Industry & Activities"];
      this.idirectorsTableData = result["Directors & Managers"];

      this.currentDataSource = result.dataSource;
      const exchangeInfo = result["Key information"].stock_exchange_listed;
      this.getData(exchangeInfo);

      if (result.f10Id) {
        this.f10Id = result.f10Id;
        this.getQuotationData(this.f10Id);
        this.getSummaryList(this.f10Id);
      }
    },

    async getData(exchangeInfo) {
      const params = {
        bvdId: this.id,
        exchangeCode: exchangeInfo,
        stockCode: this.code
      };

      if (this.currentDataSource == "f10") {
        params.quarter = 4;
      }
      const { result } = await getCompanyFinancial(params);

      this.getChartData(result);
    },

    getChartData(result) {
      if (this.currentDataSource == "f10") {
        this.f10Chart(result);
      } else {
        this.bvdChart(result);
      }
    },

    bvdChart(result) {
      let chartResult = [];
      let operatingRevenueTotal = {
        data: [],
        name: "Operating Revenue (Turnover)",
        unit: result["keyFinancial"][0]
          ? result["keyFinancial"][0].original_currency
          : ""
      };
      let PLTotal = {
        data: [],
        name: "P/L Before Tax",
        unit: result["keyFinancial"][0]
          ? result["keyFinancial"][0].original_currency
          : ""
      };
      let cashFlowTotal = {
        data: [],
        name: "Cash Flow",
        unit: result["keyFinancial"][0]
          ? result["keyFinancial"][0].original_currency
          : ""
      };
      let assetsTotal = {
        data: [],
        name: "Total Assets",
        unit: result["keyFinancial"][0]
          ? result["keyFinancial"][0].original_currency
          : ""
      };
      this.xData = [];
      for (let item of result["keyFinancial"]) {
        this.xData.push(item.year);
        operatingRevenueTotal.data.push(item.operating_revenue_turnover);
        PLTotal.data.push(item.p_l_before_tax);
        cashFlowTotal.data.push(item.cash_flow);
        assetsTotal.data.push(item.total_assets);
      }

      this.xData = this.xData.reverse();

      chartResult.push(
        operatingRevenueTotal,
        PLTotal,
        cashFlowTotal,
        assetsTotal
      );

      if (
        !chartResult[0].data.length &&
        !chartResult[1].data.length &&
        !chartResult[2].data.length &&
        !chartResult[3].data.length
      ) {
        this.serData = [];
        return;
      }
      this.converChartData(chartResult);
    },

    f10Chart(result) {
      let chartResult = [];
      let incomTotal = {
        data: [],
        name: "Operating Income",
        unit: result.financialStatement["Income Statement"][0]
          ? result.financialStatement["Income Statement"][0]
              .exchange_rate_cny_usd
          : ""
      };
      let profitTotal = {
        data: [],
        name: "Total Profit",
        unit: result.financialStatement["Income Statement"][0]
          ? result.financialStatement["Income Statement"][0]
              .exchange_rate_cny_usd
          : ""
      };
      this.xData = [];
      for (let item of result.financialStatement["Income Statement"]) {
        this.xData.push(item.year);
        incomTotal.data.push(item.operating_income);
        profitTotal.data.push(item.total_profit);
      }

      let assetsTotal = {
        data: [],
        name: "Total Assets",
        unit: result.financialStatement["Balance Sheet"][0]
          ? result.financialStatement["Balance Sheet"][0].exchange_rate_cny_usd
          : ""
      };
      let currentAssetsTotal = {
        data: [],
        name: "Current Assets",
        unit: result.financialStatement["Balance Sheet"][0]
          ? result.financialStatement["Balance Sheet"][0].exchange_rate_cny_usd
          : ""
      };
      for (let item of result.financialStatement["Balance Sheet"]) {
        assetsTotal.data.push(item.total_assets);
        currentAssetsTotal.data.push(item.current_assets);
      }
      this.xData = this.xData.reverse();

      chartResult.push(
        incomTotal,
        profitTotal,
        assetsTotal,
        currentAssetsTotal
      );
      if (
        !chartResult[0].data.length &&
        !chartResult[1].data.length &&
        !chartResult[2].data.length &&
        !chartResult[3].data.length
      ) {
        this.serData = [];
        return;
      }
      this.converChartData(chartResult);
    },

    converChartData(result) {
      const data = result.map((item, index) => {
        const itemData = {
          name: item.name,
          type: "line",
          // stack: "dta",
          data: item.data.reverse(),
          unit: item.unit,
          smooth: true,
          itemStyle: {
            normal: {
              color: color[index % 10], //改变折线点的颜色
              lineStyle: {
                color: color[index % 10] //改变折线颜色
              }
            }
          }
        };
        return itemData;
      });
      this.serData = [];
      this.serData = data;
    },

    async getQuotationData(f10Id) {
      if (!this.KDatePicker || !this.KDatePicker.length) return;
      const { result } = await getKQuotation({
        start: this.KDatePicker[0],
        f10DataId: this.f10Id,
        end: this.KDatePicker[1]
      });
      this.dailyKData = this.converData(result);
    },

    converData(data) {
      // 数据意义：开盘(open)，收盘(close)，最低(lowest)，最高(highest)
      return data.map(item => [
        item.trade_date.split(" ")[0],
        item.fopen,
        item.previous_close,
        item.low,
        item.high
      ]);
    },

    async getSummaryList(f10Id) {
      const params = {
        keyword: f10Id
      };
      const { result } = await getSummary(params);
      result.recordList.forEach(item => {
        item.announcement_date = item.announcement_date.split(" ")[0];
      });
      this.caSummaryData = result.recordList.slice(0, 5);
    },

    getFirstSentence(str) {
      return (
        str
          .split(" ")
          .slice(0, 10)
          .join(" ") + "..."
      );
    }
  }
};
</script>


<style scoped>
.company_common_title {
  /* padding-top: 10px; */
  padding: 0px;
}

.company_common_title span {
  padding-left: 10px;
  display: inline-block;
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company_mobile {
  overflow: auto;
  height: 100%;
  padding-bottom: 150px;
}
.overview {
  max-height: 150px;
  overflow-y: auto;
}
</style>